"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortLabelValues = void 0;
const LabelCategories_1 = require("./shared/LabelCategories");
const LabelType_1 = require("./shared/LabelType");
function sortLabelValues(a, b) {
    var _a, _b, _c, _d, _e;
    const aLocalizedCategory = (_a = a.localizedCategory) !== null && _a !== void 0 ? _a : a.category;
    const bLocalizedCategory = (_b = b.localizedCategory) !== null && _b !== void 0 ? _b : b.category;
    const aLocalizedValue = (_c = a.localizedValue) !== null && _c !== void 0 ? _c : a.value;
    const bLocalizedValue = (_d = b.localizedValue) !== null && _d !== void 0 ? _d : b.value;
    // TODO: this currently uses super sophisticated sorting when it could just be two group-by and sort the lists in the groups
    // a) whether the label category is built-in
    // b) whether the label type is built-in
    // c) sort category by alphabetical order
    // d) sort type by alphabetical order
    return compareCategory(a.category, b.category)
        || compareType(a.value, b.value)
        || (aLocalizedCategory > bLocalizedCategory ? 1 : (((_e = aLocalizedCategory < bLocalizedCategory) !== null && _e !== void 0 ? _e : '') ? -1 : 0))
        || (aLocalizedValue > bLocalizedValue ? 1 : -1);
}
exports.sortLabelValues = sortLabelValues;
function compareCategory(categoryA, categoryB) {
    return ((0, LabelCategories_1.isBuiltInLabelCategory)(categoryB) ? 1 : 0) - ((0, LabelCategories_1.isBuiltInLabelCategory)(categoryA) ? 1 : 0);
}
function compareType(typeA, typeB) {
    return ((0, LabelType_1.isBuiltInLabelType)(typeB) ? 1 : 0) - ((0, LabelType_1.isBuiltInLabelType)(typeA) ? 1 : 0);
}
//# sourceMappingURL=LabelValueSorting.js.map